// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1bxlh","footer":"ModalUpdate_footer__14nrO"};